import classNames from "classnames";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { selectAppState } from "./app/slices/appSelectors";
import Spinner from "./components/Loaders/Spinner";
import { loadThunk, loadTrackingThunk } from "./app/slices/appActionCreators";
import ConfirmDialog from "./calculator/components/ConfirmDialog";
import Slideout from "./components/Modals/Slideout";
import Calculator from "./calculator/components/CalculatorPage";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { ShellWindow } from "./utils/tracking";
import { isDevelopmentOrMockMode } from "./utils/utils";
import { loadAdrum } from "./utils/appDynamicsUtils";

function App() {
  const state = useAppSelector(selectAppState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadThunk());

    const handleCookieConsentChange = () => {
      const shellWindow = window as ShellWindow;
      const acceptedCookies = shellWindow.GetAcceptedCookieCategories();
      if (acceptedCookies.optimization && !isDevelopmentOrMockMode()) {
        dispatch(loadTrackingThunk());
        loadAdrum();
      }
    };

    window.addEventListener("AcceptedCookieCategoriesChange", handleCookieConsentChange);

    return () => {
      window.removeEventListener("AcceptedCookieCategoriesChange", handleCookieConsentChange);
    };
  }, [dispatch]);

  const renderModals = () => {
    if (state.modals?.length > 0) {
      return state.modals.map((modal) => {
        switch (modal.type) {
          case "ConfirmDialog": {
            return <ConfirmDialog key={modal.id} {...modal.props} id={modal.id} />;
          }
          case "Slideout": {
            return <Slideout key={modal.id} {...modal.props} id={modal.id} />;
          }
        }
      });
    }
  };

  const containerStyle = {
    display: "grid",
    gridTemplateRows: state.isLoaded ? "auto 1fr" : "1fr",
  };

  return (
    <div className={classNames("mfe-container", "use-green", !state.isLoaded && "loading")} style={containerStyle}>
      {state.isLoaded ? (
        <>
          <ErrorBoundary>
            <>
              <Calculator />
              {renderModals()}
            </>
          </ErrorBoundary>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
}

export default App;
